'use strict';

/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-define-property/index.js
 ** module id = 167
 ** module chunks = 9
 **/